module.exports = __webpack_public_path__ + "static/media/zjs-express.945ee228.svg";